import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private ManufacturersSettings Types */
import {
  Settings,
  _ManufacturersSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedManufacturerTemplate = {
  id: 0,
  name: '',
  email: '',
  website: ''
}

export default {
  namespaced: true,
  state: {
    manufacturers: [],
    allManufacturers: [],
    selectedManufacturer: _.cloneDeep(selectedManufacturerTemplate),
    openNewManufacturerDialog: false,
    branchOfficeHasManufacturers: []
  },
  mutations: {
    [_ManufacturersSettings.mutations.setManufacturers] (state, payload) {
      state.manufacturers = payload
    },
    [_ManufacturersSettings.mutations.setAllManufacturers] (state, payload) {
      state.allManufacturers = payload
    },
    [_ManufacturersSettings.mutations.setSelectedManufacturer] (state, payload) {
      if (payload !== null) {
        state.selectedManufacturer = payload
      } else {
        state.selectedManufacturer = _.cloneDeep(selectedManufacturerTemplate)
      }
    },
    [_ManufacturersSettings.mutations.setOpenCloseNewManufacturerDialogState] (state) {
      state.openNewManufacturerDialog = !state.openNewManufacturerDialog
    },
    [_ManufacturersSettings.mutations.setBranchOfficeHasManufacturers] (state, payload) {
      state.branchOfficeHasManufacturers = payload
    }
  },
  actions: {
    [_ManufacturersSettings.actions.saveManufacturers] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/manufacturers'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ManufacturersSettings.mutations.setSelectedManufacturer, r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/manufacturers/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ManufacturersSettings.mutations.setSelectedManufacturer, r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_ManufacturersSettings.actions.loadManufacturers] (context, payload) {
      console.log('loadManufacturers: ' + JSON.stringify(payload))
      console.log('loadManufacturers: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/manufacturers?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;email:like;website:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      if (payload.branch_office_id != null) {
        url += '&branch_office_id=' + payload.branch_office_id
      }

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ManufacturersSettings.mutations.setManufacturers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ManufacturersSettings.actions.loadAllManufacturers] (context, payload) {
      console.log('loadAllManufacturers: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/manufacturers'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ManufacturersSettings.mutations.setAllManufacturers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ManufacturersSettings.actions.openCloseNewManufacturerDialog] ({ commit }) {
      commit(_ManufacturersSettings.mutations.setOpenCloseNewManufacturerDialogState)
    },
    [_ManufacturersSettings.actions.setSelectedManufacturer] ({ commit }, payload) {
      commit(_ManufacturersSettings.mutations.setSelectedManufacturer, payload)
    },
    [_ManufacturersSettings.actions.loadBranchOfficeHasManufacturers] (context, payload) {
      console.log('loadBranchOfficeHasManufacturers: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/branchOfficesHasManufacturers/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ManufacturersSettings.mutations.setBranchOfficeHasManufacturers, r.data.data)
        console.log('watt is jetz hier: ' + JSON.stringify(r.data.data))
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ManufacturersSettings.actions.saveBranchOfficeHasManufacturers] (context, payload) {
      console.log('saveBranchOfficeHasManufacturers: ' + JSON.stringify(payload))

      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.selected === true) {
        var url = API_URL + '/api/v1/branchOfficesHasManufacturers'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/branchOfficesHasManufacturers/' + payload.manufacturer_id + '/' + payload.supplier_branch_offices_id

        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_ManufacturersSettings.actions.resetState] ({ commit }) {
      commit(_ManufacturersSettings.mutations.setManufacturers, [])
      commit(_ManufacturersSettings.mutations.setAllManufacturers, [])
      commit(_ManufacturersSettings.mutations.setSelectedManufacturer, null)
      commit(_ManufacturersSettings.mutations.setBranchOfficeHasManufacturers, [])
    }
  },
  getters: {
    [_ManufacturersSettings.getters.manufacturers] (state) {
      return state.manufacturers
    },
    [_ManufacturersSettings.getters.getAllManufacturers] (state) {
      return state.allManufacturers
    },
    [_ManufacturersSettings.getters.getOpenNewManufacturerDialogState] (state) {
      return state.openNewManufacturerDialog
    },
    [_ManufacturersSettings.getters.getSelectedManufacturer] (state) {
      return state.selectedManufacturer
    },
    [_ManufacturersSettings.getters.getBranchOfficeHasManufacturers] (state) {
      return state.branchOfficeHasManufacturers
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/manufacturers.js